export default "__VITE_ASSET__CBwGKVKC__"